export default __webpack_public_path__ + "static/media/logo.dfdb5a62.png";